import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({name: 'empty'})
export class EmptyPipe implements PipeTransform {
    transform(value: number | string | null | undefined, replacementStringOrValue?: string | number, allowZero: boolean = false): number | string | null | undefined {
        if (value == null) {
            return replacementStringOrValue ?? null;
        }

        if (_.isFinite(value)) {
            if (!allowZero) {
                if (!value) {
                    return replacementStringOrValue ?? null;
                }
            }
            return value;
        }

        if (_.isString(value)) {
            if (String.isNullOrUndefinedOrWhitespace(value)) {
                return replacementStringOrValue ?? null;
            }
            
            return value;
        }

        return value;
    }
}